export const EDIT_HYPERLINK_DRAFT_COMMAND = 'edit-hyperlink';
